import React, { useEffect } from "react";
import { PlanStatus, RenewCheckout } from "./Renew";
import { useDispatch } from "react-redux";
import { clearProcessData } from "../../redux/actions/processAction";
import { useParams } from "react-router-dom";
import PaymentSuccess from "../../Components/PaymentSuccess";

export default function MainPage() {
    const {step} = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearProcessData());
    },[]) // eslint-disable-line

    const renderRenewPage = () => {
        switch (step) {
            case "plan-status":
                return <PlanStatus />;
            case "checkout":
                return <RenewCheckout />;
            case "thank-you":
                return <PaymentSuccess />;
            default:
                return <PlanStatus />;
        }
    }

    return (renderRenewPage());
}
